import { buildQueryParams } from "../utils/BuildQueryParam";

export default {
    LOGIN: "/api/auth/login",
    getConfigs: "/api/v1/application-config",
    greet: "/api/greet/hello",
    createRule: "/api/v1/rules",
    getEnums: "/api/v1/rules/get-enums",
    getRules: (filters) => {
        const query = buildQueryParams(filters);
        return `/api/v1/rules${query ? `?${query}` : ""}`;
    },
    getRuleById: (id) => `/api/v1/rules/${id}`,
    updateRule: (id, status) => `/api/v1/rules/${id}/update-status?status=${status}`,
    getCatalogs: `/api/v1/catalog/metadata`,
    getCatalogLocations: (catalog_id) => `/api/v1/catalog/${catalog_id}/locations`,
    getCategoriesByCatalog: (catalog_id) => `/api/v1/catalog/${catalog_id}/categories`,
    getAllCategories: `/api/v1/catalog/categories`,
    getProductsByCatalog: (filters) => {
        const query = buildQueryParams(filters);
        return `/api/v1/catalog/products${query ? `?${query}` : ""}`;
    },
    getSkusByCatalog: (filters) => {
        const query = buildQueryParams(filters);
        return `/api/v1/catalog/skus${query ? `?${query}` : ""}`;
    },
    getCustomerGroups: () => `/api/v1/catalog/customer-groups`,
    getRequestSources: `/api/v1/catalog/request-sources`,
    updateRules: (status) => `/api/v1/rules/update-status?status=${status}`,
    deleteRules: `/api/v1/rules/delete`,
    masterDisable: (masterDisableValue) => `/api/v1/rules/master-disable?value=${masterDisableValue}`,
    getGitDiff: (ruleId) => `/api/v1/rules/${ruleId}/diff`,
    getAttributesMetaData: `/api/v1/attributes/metadata`,
    priceEvaluate: `/api/v1/pricing/evaluate`,
    simulate: `/api/v1/pricing/simulate`,
    getAllLocations: `/api/v1/catalog/all-locations`,
    getFlashsaleStockDiscounts: (filters) => {
        const query = buildQueryParams(filters);
        return `/api/v1/flashsale/stock-discounts${query ? `?${query}` : ""}`;
    },
    updateStock: `/api/v1/flashsale/stock-discounts/bulk`,
    getStoreProducts: (storeId, ruleType = null) => `/api/v1/catalog/stores/${storeId}/skus${ruleType ? `?ruleType=${ruleType}` : ""}`,
    getLiquidationStockDetails: (storeId) => `/api/v1/flashsale/liquidation-stock-details?storeId=${storeId}`,
    getFlashSaleDiscounts: (filters) => {
        const query = buildQueryParams(filters);
        return `/api/v1/flashsale/discount${query ? `?${query}` : ""}`;
    },
    saveFlashSaleDiscount: `/api/v1/flashsale/discount`,
    getProductsByStoreId: (storeId) => `/api/v1/catalog/stores/${storeId}/products`,
    getSkusByStoreId: (storeId) => `/api/v1/catalog/stores/${storeId}/skus`,
    getCategoriesByStoreId: (storeId) => `/api/v1/catalog/stores/${storeId}/categories`,
    updateFlashSaleDiscount: (id) => `/api/v1/flashsale/discount/${id}`,
    getUserProfile: `/api/v1/user-profile`,
    getSortOrder: (storeId) => `/api/v1/flashsale/sort-order?storeId=${storeId}`,
    updateSortOrder: (storeId) => `/api/v1/flashsale/sort-order?storeId=${storeId}`,
    getRuleHistory: (filters) => {
        const query = buildQueryParams(filters);
        return `/api/v1/audit/history${query ? `?${query}` : ""}`;
    }
}